import React from "react";

interface NotesPanelProps {
  title?: string;         // optional panel title
  description?: string;   // optional description text
  children?: React.ReactNode;
}

export const NotesPanel: React.FC<NotesPanelProps> = ({ title, description, children }) => {
  return (
    <div className="mt-4 p-4 rounded-xl bg-yellow-50 dark:bg-yellow-900/30 border-l-4 border-yellow-400 dark:border-yellow-500">
      {title && (
        <h3 className="text-sm font-semibold text-yellow-800 dark:text-yellow-300 mb-1">
          {title}
        </h3>
      )}
      {description && (
        <p className="text-xs text-gray-700 dark:text-gray-300 mb-2">{description}</p>
      )}
      <div className="text-sm text-gray-800 dark:text-gray-100 space-y-2">{children}</div>
    </div>
  );
};

export default NotesPanel;
